import React, { useEffect, useState } from "react";
import { Button, Col, Row, Modal, ModalBody, ModalFooter, ModalHeader, TabPane, Form } from "reactstrap";
import { Avatar, Badge, Card, Spin, Tabs, Tag } from "antd";
import { formatDate } from '../../../Components/Common/FormatDate/FormatDate';
import CardImageItem from "../../Users/component/CardImage";
import "../../Styles/style.css";
import { useFormik } from "formik";
import { updateUserRole } from "../services/driverApi";
import * as Yup from "yup";
import FormField from "../../../Components/Common/Form/FormField";
import SelectField from "../../../Components/Common/Form/SelectField";

const HistoryUser = ({ modal, setModal, toggle, selectedUser, userHistory }) => {
  const history = userHistory || [];
  const { name, email, phone, address, licenseNumber, createdAt, updatedAt, status, role, vehicle, fileName } = selectedUser || {};
  const roleName = role?.name || "-";
  const { brand, model, registrationNumber, commissioningDate } = vehicle || {};

  const [isLoading, setIsLoading] = useState(false);

  console.log('selectedUser =>', selectedUser)
  const rolesOptions = [
      { id: "DRIVER", name: "Chauffeur" },
      { id: "INTERVENANT", name: "Intervenant" },
    ];

    const validationSchema = Yup.object().shape({
      role: Yup.string().required("Merci de selectionner un role"),
    });

    const initialValues = {
      name: selectedUser?.name,
      email: selectedUser?.email,
      phone: selectedUser?.phone,
      address: selectedUser?.address || "",
      licenseNumber: selectedUser?.licenseNumber || "",
      role: selectedUser?.role?.name || "",
    };
    
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        setIsLoading(true);
        
        const userData = {
          userKeycloakId: selectedUser?.userKeycloakId,
          oldRoleName: selectedUser?.role?.name,
          newRoleName: values.role
        };

      try{  
        console.log('avant update', userData)
        await updateUserRole(userData);
          toast.success("Role modifié avec succès",
            {
            duration: 10000,
            }
        );
        await queryClient.invalidateQueries("users");
        toggle();
        formik.resetForm();
      } catch (error) {
        toast.error(`Erreur: ${error?.message || error}`);
        
        } finally {
        setIsLoading(false);
        }
      },
    });
  const isRoleUnchanged = formik.values.role === selectedUser?.role?.name;


  

  return (
    <Modal isOpen={modal} toggle={toggle} centered backdrop="static" style={{ maxWidth: "900px" }}>
      <ModalHeader className="bg-info-subtle p-3" toggle={toggle}>
        <span>Historique du chauffeur {name || "-"} </span>
      </ModalHeader>

      <ModalBody>
        <div className="text-center mb-4">
          <Avatar size={300} style={{ width: "150px", height: "150px", overflow: "hidden" }}>
            <CardImageItem fileName={fileName} />
          </Avatar>
        </div>

        <div className="text-center mb-4">
          <h4>{name || '-'}</h4>
          <p>{roleName === "DRIVER" ? "Chauffeur" : "-"}</p>
          <p>
            {status ? (
              <Tag color={status === "ACTIF" ? "green" : "red"}>
                {status}
              </Tag>
            ) : " - "}
          </p>
        </div>

        <Tabs defaultActiveKey="1" centered>
          <TabPane tab="Détails du compte" key="1">
            <Card className="card-animate" title="Détails de Compte" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
              <Row>
                <Col lg={6}>Téléphone : <span>{phone || '-'}</span></Col>
                <Col lg={6}>Address : <span>{address || '-'}</span></Col>
                <Col lg={6}>Permis : <span>{licenseNumber || '-'}</span></Col>
                <Col lg={6}>Créé le : <span>{formatDate(createdAt) || '-' }</span></Col>
                <Col lg={6}>Email : <span>{email || '-'}</span></Col>
                <Col lg={6}>Statut : <span>{status || '-'}</span></Col>
              </Row>
            </Card>
          </TabPane>

          <TabPane tab="Véhicule actuel" key="2">
            <Card className="card-animate" title="Actuel véhicule" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
              {
                vehicle && Object.keys(vehicle).length > 0 ? (
                  <Row>
                    <Col lg={3}>Marque : <span>{brand || '-'}</span></Col>
                    <Col lg={3}>Modèle : <span>{model || '-'}</span></Col>
                    <Col lg={3}>Plaque : <span>{registrationNumber || '-'}</span></Col>
                    <Col lg={3}>En service : <span>{commissioningDate || '-'}</span></Col>
                  </Row>
                ) : (
                  <div className="text-center">Pas de voiture rattachée actuellement !</div>
                )
              }
            </Card>
          </TabPane>

          <TabPane tab={`Anciens véhicules (${history.length})`} key="3">
            <Card className="card-animate" title="Les anciens véhicules" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
              {
                history.length > 0 ? (
                  history.map((userHistory, index) => (
                    <Row key={index}>
                      <Col lg={3}>Marque : <span>{userHistory?.brand || '-'}</span></Col>
                      <Col lg={3}>Modèle : <span>{userHistory?.model || '-'}</span></Col>
                      <Col lg={3}>Plaque : <span>{userHistory?.registrationNumber || '-'}</span></Col>
                      <Col lg={3}>En service : <span>{userHistory?.commissioningDate || '-'}</span></Col>
                      {index < history.length - 1 && <hr style={{ border: '0', borderTop: '2px solid #00bcd4', margin: '20px 0', opacity: 0.5, borderRadius: '5px' }} />}
                    </Row>
                  ))
                ) : (
                  <div className="text-center">Pas d'anciens véhicules pour cet utilisateur</div>
                )
              }
            </Card>
          </TabPane>

          <TabPane tab={`Paramètres `} key="4">
            <Card className="card-animate" title="Paramétrage" style={{ marginBottom: 20, boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
            
              <Row >
                <Form onSubmit={formik.handleSubmit}>
                  
                    <Row>
                      <FormField label="Email" name="email" formik={formik} type="email" colSize={6} placeholder="Entrez son adresse email" disabled/>
                      <FormField label="Téléphone" name="phone" formik={formik} type="number" colSize={6} placeholder="Entrez le numéro de téléphone" disabled/>
                      <SelectField label="Role" name="role" formik={formik} options={rolesOptions} nameSelect="le role" colSize={6} />
                      <FormField label="Adresse" name="address" formik={formik} colSize={6} placeholder="Entrez son adresse" disabled/>
                      
                    </Row>
                              
                    <Button type="submit" className="btn btn-soft-success" disabled={isLoading || isRoleUnchanged}>
                      {isLoading ? <Spin size="small" /> : "Modifier le role"}
                    </Button>
                </Form>
              </Row>
            </Card>
            {isRoleUnchanged && (
              <small className="text-muted">
                Le rôle actuel est déjà sélectionné
              </small>
            )}

          </TabPane>
        </Tabs>
      </ModalBody>

      <ModalFooter>
        <Button className="active-tab" onClick={() => setModal(false)}>Fermer</Button>
      </ModalFooter>
    </Modal>
  );
};

export default HistoryUser;
